import StorageService from "../services/StorageService";
import { buildLoginPath } from "./authRedirect";

export const buildProcurementRequestReturnPath = (serviceCode) => {
  const params = new URLSearchParams({
    service: serviceCode,
    action: "request",
  });
  return `/dashboard/p2p/services?${params.toString()}`;
};

/**
 * Navigate logged-in users to the PAS request form; guests go to login first.
 * @param {(path: string, options?: object) => void} navigate
 * @param {string} serviceCode - backend service_code
 */
export const goToProcurementRequest = (navigate, serviceCode) => {
  const returnTo = buildProcurementRequestReturnPath(serviceCode);
  if (!StorageService.isAuthenticated()) {
    navigate(buildLoginPath(returnTo));
    return;
  }
  navigate(returnTo);
};
